import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";
import { IButtonProps } from "./IButtonProps";

@observer
export class SaveButton extends React.Component<IButtonProps> {

	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown)
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	onKeyDown = (event: KeyboardEvent) => {
		if (event.ctrlKey && event.keyCode == 83) {
			event.preventDefault();
			if (!this.props.disabled) {
				this.props.onClick(null);
			}
		}
	}

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.general.saveButtonLabel}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M26,0V10H6V0H0V32H32V0H26ZM6,28V24H26v4H6Z" />
					<rect x="8" width="6" height="8" />
				</svg>
			</i>
		</Button>;
	}
}
